import React from "react";

/**
 * onClose  - dismiss without acting (click outside)
 * onReport - user tapped "Report" — parent switches to ReportModal
 * onBlock  - user tapped "Block" — parent runs the block flow
 * isBlocking - true while the block request is in flight
 */
const ProfileOptionsModal = ({ onClose, onReport, onBlock, isBlocking }) => {
  const handleOverlayClick = () => {
    if (!isBlocking) onClose();
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center">
      <div
        className="absolute inset-0 bg-black/40 backdrop-blur-sm transition-opacity"
        onClick={handleOverlayClick}
      />

      <div className="relative w-full bg-white dark:bg-gray-900 rounded-t-2xl max-h-[60vh] flex flex-col animate-slide-up sm:max-w-xl sm:mx-auto">
        <div className="p-4">
          <button
            onClick={onReport}
            disabled={isBlocking}
            className="w-full py-3 text-center rounded-lg font-semibold text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors disabled:opacity-50"
          >
            Report
          </button>

          <hr className="mx-2 border-t border-gray-200 dark:border-gray-800" />

          <button
            onClick={onBlock}
            disabled={isBlocking}
            className="w-full py-3 text-center rounded-lg font-semibold text-sm text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors disabled:opacity-50"
          >
            {isBlocking ? "Blocking..." : "Block"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfileOptionsModal;